import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import './RRActivo.css';

import DiamondIcon from '@mui/icons-material/Diamond';
//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faCircleExclamation,
  faBell,
  faBook,
  faScrewdriverWrench,
  faCircleUp,
  faCircleDown,
  faFolder,
  faToggleOn,
  faToggleOff,
  faToolbox,
  faCheckDouble,
  faCookieBite,
  faListDots
} from "@fortawesome/free-solid-svg-icons";
import AnimatedCount from "../animatedCount/AnimatedCount";
import ModalForm from "../modalForm/ModalForm";
import checklistContext from "../../context/checklistContext/checklistContext";
import moment from "moment";
import authContext from "../../context/authentication/authContex";
import activoContext from "../../context/activoContex/activoContex";
import Swal from "sweetalert2";
import Stopwatch from "../stopwatch/Stopwatch";
import controlContext from "../../context/control/controlContext";
import DictionaryText from "../dictionaryText/DictionaryText";

const RRActivo = ({activo, index, setActivoToEdit, indexToEdit, setIndexToEdit, indexAddConsumo, setIndexAddConsumo, setFormToShow, componentePadre, activosForLocalStorage}) =>{

    const [showCountsProcsDiv, setShowCountsProcsDiv] = useState((activo.procsPorVencerCount > 0 || activo.procsVencidosCount > 0));
    const [showCountsProcsChecklistDiv,setShowCountsProcsChecklistDiv] = useState(activo.procsChecklistPorVencerCount > 0 || activo.procsChecklistVencidosCount > 0);
    const [showCountsProcsDirectosDiv,setShowCountsProcsDirectosDiv] = useState((activo.procsDirectosPorVencerCount > 0 || activo.procsDirectosVencidosCount > 0));
    const [showCountsDocsDiv, setShowCountsDocsDiv] = useState((activo.docsVencidosCount > 0 || activo.docsPorVencerCount > 0));
    const [showModalForm,setShowModalForm] = useState(false);
    const {getChecklistRunningByActivoID, finalizarChecklistReg, getTDocsWithCKAssociated, checklistRegList} = useContext(checklistContext);
    const {usuario,globalSettings, checkIfOnlyRevisor} = useContext(authContext);
    const {updateUserWorking, procsProgramadosList, docsXactivoList, cargandoProcsProgramados} = useContext(activoContext);
    const {listTDoc} = useContext(controlContext);    

    const [showModalLecturas,setShowModalLecturas] = useState(false);
    const [modalToShow, setModalToShow] = useState('');
    const [tDocsToAssociate,setTDocsToAssociate] = useState([]);

    const [checklistSaved, setChecklistSaved] = useState(null);
    const [showStopwatch, setShowStopwatch] = useState(false);
    const [timer,setTimer] = useState(0);

    const checklistRunningRef = useRef(null);
    const navigate = useNavigate();
    const widthWindow = window.innerWidth;

    const [showButtons, setShowButtons] = useState(false);

    const handleClickInfoActivo = (view, tipoAlerta, procSelected = "") => {
        if(globalSettings?.openNewtab){
            //Setea el activo por el que se filtraran los documentos o procedimientos programados.
            localStorage.setItem('activoToSearch', `"${activo.codActivo}"`);
            
            //Testeando enviar arreglos de los contextos como strings y recuperarlo en la nueva pestaña.
            localStorage.setItem('procsProgramados', JSON.stringify(procsProgramadosList));
            localStorage.setItem('ordenesTrabajo', JSON.stringify(listTDoc));
            localStorage.setItem('checklistReg', JSON.stringify(checklistRegList));
            localStorage.setItem('documentosList', JSON.stringify(docsXactivoList));
            localStorage.setItem('activosList', activosForLocalStorage);//Los activos ya estan convertidos a string.
            
            //Setea por el tipo de alerta que se filtraran los documentos o procedimientos programados.
            localStorage.setItem('workspaceSelected',tipoAlerta);
            //Setea el ORIGEN al querer visualizar Procedimientos.
            if(procSelected != "") localStorage.setItem('origen',procSelected);
            //Abre en una pestaña nueva la vista especificada (Procedimientos o Documentos).
            window.open(`${window.location.origin}/${view}`, "_blank");
        }else{
            navigate(`/${view}`,{state:{activoToSearch: `"${activo.codActivo}"`, workspaceSelected:tipoAlerta, origen: procSelected}});
        }
    }

    const handleAgregarLectura = () => {
        setIndexToEdit(index);
        setActivoToEdit(activo);
        setFormToShow('lectura');
    }
    
    const handleSetFServ = () => {
        setIndexToEdit(index);
        setActivoToEdit(activo);
        setFormToShow('fserv');
    }

    const handleAddProcCorrectivo = () => {
        setIndexToEdit(index);
        setActivoToEdit(activo);
        setFormToShow('procedimiento');
    }

    const handleAddConsumo = () => {
        setIndexAddConsumo(index);
        setActivoToEdit(activo);
    }
    
    const handleRegisterChecklist = () => {
        if(activo.userWorking){
            Swal.fire({
                title:'Ops!',
                text:'El activo poseé un checklist corriendo actualmente.',
                icon:'error'
            })
        }else{
            handleShowModalForm('controles')
        }
    }

    const handleShowModalForm = (formToShow) =>{
        setIndexToEdit(index);
        setActivoToEdit(activo);
        setFormToShow(formToShow);
    }

    const handleEndChecklist = async () => {
        let res = await getChecklistRunningByActivoID(activo._id);
        if(res){
            checklistRunningRef.current = res;
            setShowModalLecturas(true);
            setModalToShow('lectura');
            setActivoToEdit(activo);
        }else{
            await updateUserWorking(activo._id, '');
        }
    }

    const saveAndFinishChecklist = async (valorLectura) =>{
        try {
            setModalToShow('');
            setActivoToEdit({});

            let fecFinToSave = moment(checklistRunningRef.current.fecInicio).add(checklistRunningRef.current.secondsRunning - 2, 'seconds').format('YYYY-MM-DD HH:mm:ss');
            
            let res = await finalizarChecklistReg({...checklistRunningRef.current, tiempoCronometro: checklistRunningRef.current.secondsRunning, fecFin: fecFinToSave, state: 'FINALIZADO'}, {userName: usuario.userName, _id: usuario._id});

            await updateUserWorking(activo._id, '');

            Swal.fire({
                title:'Checklist finalizado!',
                text:`El checklist ${checklistRunningRef.current.codigo} - ${checklistRunningRef.current.checkNro} se ha finalizado correctamente`,
                icon:'success'
            });

            checklistRunningRef.current = null;
        } catch (error) {
            let res = await getChecklistRunningByActivoID(activo._id);
            if(!res){
                await updateUserWorking(activo._id, '');
            }
            console.log("error en saveAndFinishChecklist");
            console.log(error);
        }
    }

    const handleMinimizarModalLectura = async (flag, accion) => {
        if(!flag && accion == 'close'){
            setShowModalLecturas(false);
            setModalToShow('');
            setActivoToEdit({});
            checklistRunningRef.current = null;
        }else if(flag){
            let tDocs = await getTDocsWithCKAssociated(checklistRunningRef.current.checklistID, activo._id);
            if(Array.isArray(tDocs) && tDocs.length > 0){
               setTDocsToAssociate(tDocs);
               setModalToShow('associateCkToTDoc');
            }else{
                saveAndFinishChecklist();
            }
        }
    }

    const handleMinimizarModalAssociateToODT = async (flag) => {
        saveAndFinishChecklist();
    }

    useEffect(()=>{
        setShowCountsProcsDiv(activo.procsPorVencerCount > 0 || activo.procsVencidosCount > 0)
        setShowCountsProcsChecklistDiv(activo.procsChecklistPorVencerCount > 0 || activo.procsChecklistVencidosCount > 0)
        setShowCountsProcsDirectosDiv(activo.procsDirectosPorVencerCount > 0 || activo.procsDirectosVencidosCount > 0)
        setShowCountsDocsDiv(activo.docsVencidosCount > 0 || activo.docsPorVencerCount > 0)
    },[activo.procsPorVencerCount, activo.procsVencidosCount, activo.procsChecklistPorVencerCount, activo.procsChecklistVencidosCount, activo.procsDirectosPorVencerCount, activo.procsDirectosVencidosCount, activo.docsVencidosCount, activo.docsPorVencerCount])

    useEffect(()=>{
        if(activo && activo.userWorking){
            let fn = async() => {
                let res = await getChecklistRunningByActivoID(activo._id);
                setChecklistSaved(res);
                return res;
            } 
            fn(); 
        } 
    },[activo])

    return <div className={`activoRow ${showModalLecturas && 'notRescalate'}`}>
        <div className={`firstRow ${(!showCountsProcsDiv) ? 'allCornersRadius' : ''} ${(showCountsDocsDiv) ? 'showingDocs' : ''}`}>
            <div className={`infoContainer`}>
                <DiamondIcon style={{pointerEvents:"none"}} className="rrIcon"/>
                <div className="infoDiv">
                    <h6>Codigo Activo:</h6>
                    <label id="codActivoLabel">{activo.codActivo}</label>
                </div>
                <div className="infoDiv">
                    <h6>Nombre Activo:</h6>
                    <label className="labelInfoActivo">{activo.name}</label>
                </div>
                <div className="infoDiv" style={{display:(widthWindow < 1000) ? 'none' : 'block'}}>
                    <h6><DictionaryText text={"Nivel 1"} componentType={"h6"}/>:</h6>
                    <label className="labelInfoActivo">{activo.nivel1Name}</label>
                </div>
                <div className="infoDiv" style={{display:(widthWindow < 1000) ? 'none' : 'block'}}>
                    <h6><DictionaryText text={"Nivel 2"} componentType={"h6"}/>:</h6>
                    <label className="labelInfoActivo" id="nivel2LabelActivoRow">{activo.nivel2Name}</label>
                </div>
                <div className="infoDiv">
                    <h6>Estado:</h6>
                    <label className="infoFServLabel" style={{backgroundColor:(activo.actStatus && activo.actStatus == 'FSERV') ? 'red' : 'green'}}>{(activo.actStatus && activo.actStatus == 'FSERV') ? 'Fuera de Servicio' : 'Disponible'}</label>
                </div>
                {
                    activo.DEFAULTUNIMED2?.value ? <div className="infoDiv">
                        <h6>Ult. Lecturas</h6>
                        <label>{`${(activo.DEFAULTUNIMED.value == 'KM') ? 'KM' : activo.DEFAULTUNIMED.label}`}: {activo.lastLectura}</label>
                        <label>{`${(activo.DEFAULTUNIMED2.value == 'KM') ? 'KM' : activo.DEFAULTUNIMED2.label}`}: {activo.lastLectura2}</label>
                    </div> : <div className="infoDiv">
                    <h6>Ult. Lectura {`${(activo.DEFAULTUNIMED.value == 'KM') ? 'KM' : activo.DEFAULTUNIMED.label}`}:</h6>
                    <label>{activo.lastLectura}</label>
                </div>
                }
                {activo.lastLecturaMenosAjuste && <div className="infoDiv">
                    <h6>Ult. Lectura Menos Ajuste:</h6>
                    <label>{activo.lastLecturaMenosAjuste}</label>
                </div>}
                {(activo.userWorking != undefined && activo.userWorking != '' && !checkIfOnlyRevisor()) && <div className="infoDiv infoDivTAHO">
                    <div className="workingNowLabel">
                        <h6>Trabajando Ahora:</h6>
                        <label>{activo.userWorking}</label>
                    </div>
                    <button className="endCkBtn" onClick={handleEndChecklist}>FINALIZAR<br/> CHECKLIST</button>
                    {
                        checklistSaved?.visualizarCrono && <Stopwatch componentePadre={"RRActivo"} checklistSaved={checklistSaved} setShowStopwatch={setShowStopwatch} setTimer={setTimer} isRunning={true}/>
                    }
                </div>}
            </div>
            {

            }
            {/* {
                !showButtons ? 
                <div onMouseEnter={()=>setShowButtons(true)} style={{paddingRight:18, paddingLeft:18, backgroundColor:'rgb(2, 141, 231)', height:'100%', display:'flex', alignItems:'center', borderTopRightRadius: 5, borderBottomRightRadius: 5}}>
                    <FontAwesomeIcon icon={faListDots} color="white"/>
                </div>
                : showButtons && componentePadre == 'Activos' && <div className={`funcionesDiv ${showCountsDocsDiv ? 'showingDocs' : ''}`} onMouseLeave={()=>setShowButtons(false)}>
                    <FontAwesomeIcon title={(!activo.fServ) ? "Colocarlo Fuera de Servicio" :  "Colocarlo Disponible"} icon={(activo.actStatus && activo.actStatus == 'FSERV') ? faToggleOff : faToggleOn} className='rrIcon' id="fServIcon" onClick={handleSetFServ}/> 
                    <FontAwesomeIcon title="Agregar Lectura" icon={faBook} className='rrIcon' onClick={handleAgregarLectura}/>
                    <FontAwesomeIcon title="Agregar Procedimiento" icon={faToolbox} className='rrIcon' onClick={handleAddProcCorrectivo}/>
                    <FontAwesomeIcon title="Agregar Consumo" icon={faCookieBite} className='rrIcon' onClick={handleAddConsumo}/>
                    <FontAwesomeIcon title="Registrar Checklist" icon={faCheckDouble} className='rrIcon' onClick={handleRegisterChecklist}/>
                </div>
            } */}
            
            <div 
                onMouseEnter={()=>setShowButtons(true)} 
                onMouseLeave={()=>setShowButtons(false)} 
                className={`functionsDivTest ${showButtons ? 'expanded' : ''} ${showCountsDocsDiv ? 'showingDocs' : ''}`}
                style={{height:'100%', alignItems:'center'}}
            >
                <div className={`${showButtons ? 'hidden' : ''} faListDotsDiv`}>
                    <FontAwesomeIcon icon={faListDots} color="white"/>
                </div>
                {
                    componentePadre == 'Activos' && <div className={`funcionesDiv ${showCountsDocsDiv ? 'showingDocs' : ''} ${showButtons ? '' : 'hidden'}`} >
                        <FontAwesomeIcon title={(!activo.fServ) ? "Colocarlo Fuera de Servicio" :  "Colocarlo Disponible"} icon={(activo.actStatus && activo.actStatus == 'FSERV') ? faToggleOff : faToggleOn} className='rrIcon' id="fServIcon" onClick={handleSetFServ}/> 
                        <FontAwesomeIcon title="Agregar Lectura" icon={faBook} className='rrIcon' onClick={handleAgregarLectura}/>
                        <FontAwesomeIcon title="Agregar Procedimiento" icon={faToolbox} className='rrIcon' onClick={handleAddProcCorrectivo}/>
                        <FontAwesomeIcon title="Agregar Consumo" icon={faCookieBite} className='rrIcon' onClick={handleAddConsumo}/>
                        <FontAwesomeIcon title="Registrar Checklist" icon={faCheckDouble} className='rrIcon' onClick={handleRegisterChecklist}/>
                    </div>
                }
            </div>
            
        </div>
        {(cargandoProcsProgramados && !checkIfOnlyRevisor()) && <div className="mainCountsDiv">
            <div className={`subMainCountsDiv`} id="cargandoCountsWarning">
                <h4>Procedimientos</h4>
                <div className="countsDiv">
                    <div className="countDiv" id="vencCountDiv" onClick={()=> (activo.procsVencidosCount > 0) && handleClickInfoActivo('procsProgramados','vencidos','CALCULO')}>
                        <h5 className="warningStatusMsg">Cargando <span>.</span><span>.</span><span>.</span></h5>
                    </div>
                </div>
            </div>
        </div>
        }
        {((showCountsProcsDiv || showCountsDocsDiv || showCountsProcsChecklistDiv || showCountsProcsDirectosDiv) && !cargandoProcsProgramados && !checkIfOnlyRevisor()) && <div className="mainCountsDiv">
            <div className={`subMainCountsDiv ${(!showCountsProcsDiv) && 'inactive'}`} id="procsCountsDiv">
                <h4><DictionaryText text={"Proc. Calculados"}/></h4>
                <div className="countsDiv">
                    <div className="countDiv" id="vencCountDiv" onClick={()=> (activo.procsVencidosCount > 0) && handleClickInfoActivo('procsProgramados','vencidos','CALCULO')}>
                        <h5 className="countLabel" ><FontAwesomeIcon icon={faCircleExclamation} className='icon-navbar' /> Vencidos: </h5>
                        <AnimatedCount key={`${activo.codActivo}-procsVencidosCount`} count={activo.procsVencidosCount}/>
                    </div>
                    <div className="countDiv" id="porVencCountDiv" onClick={()=> (activo.procsPorVencerCount > 0) && handleClickInfoActivo('procsProgramados','porVencer','CALCULO')}>
                        <h5 className="countLabel" ><FontAwesomeIcon icon={faBell} className='icon-navbar' /> Por vencer: </h5>
                        <AnimatedCount key={`${activo.codActivo}-procsPorVencerCount`} count={activo.procsPorVencerCount}/>
                    </div>
                </div>
            </div>
            <div className={`subMainCountsDiv ${(!showCountsProcsDirectosDiv) && 'inactive'}`} id="procsCountsDiv">
                <h4><DictionaryText text={"Proc. Directos"}/></h4>
                <div className="countsDiv">
                    <div className="countDiv" id="vencCountDiv" onClick={()=> (activo.procsDirectosVencidosCount > 0) && handleClickInfoActivo('procsProgramados','vencidos','DIRECTO')}>
                        <h5 className="countLabel" ><FontAwesomeIcon icon={faCircleExclamation} className='icon-navbar' /> Vencidos: </h5>
                        <AnimatedCount key={`${activo.codActivo}-procsDirectosVencidosCount`} count={activo.procsDirectosVencidosCount}/>
                    </div>
                    <div className="countDiv" id="porVencCountDiv" onClick={()=> (activo.procsDirectosPorVencerCount > 0) && handleClickInfoActivo('procsProgramados','porVencer','DIRECTO')}>
                        <h5 className="countLabel" ><FontAwesomeIcon icon={faBell} className='icon-navbar' /> Por vencer: </h5>
                        <AnimatedCount key={`${activo.codActivo}-procsDirectosVencidosCount`} count={activo.procsDirectosPorVencerCount}/>
                    </div>
                </div>
            </div>
            <div className={`subMainCountsDiv ${(!showCountsProcsChecklistDiv) && 'inactive'}`} id="procsCountsDiv">
                <h4><DictionaryText text={"Proc. desde Checklist"}/></h4>
                <div className="countsDiv">
                    <div className="countDiv" id="vencCountDiv" onClick={()=> (activo.procsChecklistVencidosCount > 0) && handleClickInfoActivo('procsProgramados','vencidos','CHECKLIST')}>
                        <h5 className="countLabel" ><FontAwesomeIcon icon={faCircleExclamation} className='icon-navbar' /> Vencidos: </h5>
                        <AnimatedCount key={`${activo.codActivo}-procsChecklistVencidosCount`} count={activo.procsChecklistVencidosCount}/>
                    </div>
                    <div className="countDiv" id="porVencCountDiv" onClick={()=> (activo.procsChecklistPorVencerCount > 0) && handleClickInfoActivo('procsProgramados','porVencer','CHECKLIST')}>
                        <h5 className="countLabel" ><FontAwesomeIcon icon={faBell} className='icon-navbar' /> Por vencer: </h5>
                        <AnimatedCount key={`${activo.codActivo}-procsChecklistPorVencerCount`} count={activo.procsChecklistPorVencerCount}/>
                    </div>
                </div>
            </div>
             <div className={`subMainCountsDiv ${(!showCountsDocsDiv) && 'inactive'}`}>
                <h4>Documentos</h4>
                <div className="countsDiv">
                    <div className="countDiv" id="vencCountDiv" onClick={()=>(activo.docsVencidosCount > 0) && handleClickInfoActivo('documentos','vencidos')}>
                        <h5 className="countLabel" ><FontAwesomeIcon icon={faCircleExclamation} className='icon-navbar' /> Vencidos: </h5>
                        <AnimatedCount key={`${activo.codActivo}-docsVencidosCount`} count={activo.docsVencidosCount}/>
                    </div>
                    <div className="countDiv" id="porVencCountDiv" onClick={()=>(activo.docsPorVencerCount > 0) && handleClickInfoActivo('documentos','porVencer')}>
                        <h5 className="countLabel" ><FontAwesomeIcon icon={faBell} className='icon-navbar' /> Por vencer: </h5>
                        <AnimatedCount key={`${activo.codActivo}-docsPorVencerCount`} count={activo.docsPorVencerCount}/>
                    </div>
                </div>
            </div>
        </div>}
        {modalToShow != '' && <ModalForm activoToEdit={activo} componentePadre={"RRActivo"} indexToEdit={index} setIndexToEdit={setIndexToEdit} formToShow={modalToShow} setFormToShow={setFormToShow} tDocsToAssociate={tDocsToAssociate} minimizar={(modalToShow == 'lectura') ? handleMinimizarModalLectura : handleMinimizarModalAssociateToODT} checklistSaved={checklistRunningRef.current}/>}
    </div>
}

export default RRActivo;